module.exports = __webpack_public_path__ + "img/ic-photo.1eaee313.svg";